import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// "Kariesha Drayton" → "Kariesha"; fallback parses email prefix:
// "kariesha.drayton@x.com" / "kariesha_drayton" → "Kariesha".
export function firstNameOf(user) {
  const source = (user?.name || user?.email?.split("@")[0] || "").trim();
  const first = source.split(/[\s._-]+/)[0] || "";
  if (!first) return "there";
  return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
}
